import PopUpCard from '../components/socionics/cards/InfoCardSocionics';
import TidBitsCard from '../components/socionics/cards/TidBitsCard';
import RelationsTable from '../components/socionics/charts/RelationsTable';
import BarChart from '../components/socionics/charts/BarChart';
import InputForm from '../components/input/InputForm';
import { getRelation } from '../calculators/socionics/functions/getRelation';
import { whichRelationIsThis } from '../calculators/socionics/functions/whichRelation';
import { Type } from '../calculators/socionics/objects/Type';
import {personalities} from '../data/socionics/data/types'
import { typeInfo } from '../data/socionics/data/typesInfo';
import { info } from '../data/socionics/data/tidBits';
import DichotomyPyramid from './DichotomyPyramid';
function SocionicsContent(props){
  let type1 = new Type(props.p1)
  let type2 = new Type(props.p2)
  let val = getRelation(type1,type2)
  let rel = whichRelationIsThis(val)

  let dif;
  let bod;
  let dif2;
  let bod2;
  for(let i=0; i< info.length; i++){
    if(info[i].head === props.p1 && info[i].head === props.p2){
      dif = info[i].difficult
      bod = info[i].body
      dif2 = info[i].difficult
      bod2 = info[i].body
    }
    else if(info[i].head === props.p1){
      bod = info[i].body
      dif = info[i].difficult
    }
    else if(info[i].head === props.p2){
      bod2 = info[i].body
      dif2 = info[i].difficult
    }
  }

return (
    <div className='bg-light' style={{paddingTop:'150px',paddingBottom:'150px'}}>
      <InputForm handleChange={props.handleChange} 
      handleChange1={props.handleChange1}/>
      <PopUpCard p1={props.p1} p2={props.p2} head={rel} body={typeInfo[val-1]}/>
      {props.p1? <BarChart p1={props.p1}/>: <></>}
      {props.p1? <TidBitsCard difficult={dif} p1={props.p1} body={bod} difficult2={dif2} p2={props.p2} body2={bod2}/> : <></>}
      <RelationsTable data={personalities}/>
      {/* performance reduced due to dichotomy pyramid */}
      <DichotomyPyramid/>
    </div>
)
}

export default SocionicsContent;
